<script lang="ts">
    import LoginSection from './login/LoginSection.svelte';
    import {
        Collapse,
        Navbar,
        NavbarToggler,
        NavbarBrand,
        Nav,
        NavItem,
        NavLink,
    } from 'sveltestrap';
    import { loginStatus } from '../store/loginV2.js';
    import { LoginStatus } from '../../common/types';

    let isOpen = false;

    function handleUpdate(event) {
        isOpen = event.detail.isOpen;
    }
</script>

<Navbar color="dark" dark expand="md" style="height: 100%">
    <NavbarBrand href="/">AI Slides</NavbarBrand>
    <NavbarToggler on:click={() => (isOpen = !isOpen)} />
    <Collapse {isOpen} navbar expand="md" on:update={handleUpdate}>
        <Nav class="me-auto" navbar>
            <NavItem>
                <NavLink href="/#/">Home</NavLink>
            </NavItem>
            <NavItem>
                <NavLink href="/#/add-suggestion">Suggest a Topic</NavLink>
            </NavItem>
            {#if $loginStatus.status === LoginStatus.LOGGED_IN}
                <NavItem>
                    <NavLink href="/#/list-suggestions"
                        >Review Suggestions</NavLink
                    >
                </NavItem>
                <NavItem>
                    <NavLink href="/#/new-presentation"
                        >New Presentation</NavLink
                    >
                </NavItem>
                <NavItem>
                    <NavLink href="/#/story">Story Mode</NavLink>
                </NavItem>
            {/if}
        </Nav>
        <Nav class="ms-auto" navbar>
            <LoginSection />
        </Nav>
    </Collapse>
</Navbar>
